// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"def5e0c8","216":"5bf9fe73","230":"b4dddc28","315":"f9e73c6c","380":"514e732f","539":"a11647c7","868":"cd8b04d4"}[chunkId] + ".chunk.js";
};